import { render, staticRenderFns } from "./icon-base.vue?vue&type=template&id=250c092b&scoped=true&"
import script from "./icon-base.vue?vue&type=script&lang=js&"
export * from "./icon-base.vue?vue&type=script&lang=js&"
import style0 from "./icon-base.vue?vue&type=style&index=0&id=250c092b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250c092b",
  null
  
)

export default component.exports